import * as React from "react";

// CSS & SCSS
import "./assets/fonts/inter.css";
import "./assets/fonts/material.css";
import "./assets/fonts/icofont/icofont.css";
import "./assets/fonts/custom.css";
import "bootstrap/dist/css/bootstrap.min.css";
import "./assets/sass/styles.scss";
import { AuthProvider } from "./context/AuthContext";
import { ValidationProvider } from "./context/ValidationContext";
import { ProtectedRoute } from "./pages/auth/ProtectedRoute";
// JS & COMPONENTS
import "./i18n";
import { createRoot } from "react-dom/client";
import { ThemeProvider } from "./context/Themes";
import { SidebarProvider } from "./context/Sidebar";
import { LoaderProvider } from "./context/Preloader";
import { TranslatorProvider } from "./context/Translator";
import { createBrowserRouter, RouterProvider } from "react-router-dom";
import { LoginPage, RegisterPage, ForgotPasswordPage } from "./pages/auth";
import {
  OverviewPage,
  DocumentationPage,
  ChangeLogPage,
  ErrorPage,
} from "./pages/others";
import {
  AvatarPage,
  AlertPage,
  ButtonPage,
  ChartPage,
  TablePage,
  FieldPage,
  HeadingPage,
  ColorPage,
} from "./pages/ui";
import {
  EcommercePage,
  AnalyticsPage,
  CRMPage,
  UserListPage,
  UserProfilePage,
  MyAccountPage,
  ProductListPage,
  ProductViewPage,
  ProductUploadPage,
  InvoiceListPage,
  InvoiceDetailsPage,
  OrderListPage,
  MessagePage,
  NotificationPage,
  BlankPage,
  SettingsPage,
} from "./pages/main";
import VendorsPage from "./pages/Admin/Vendors";
import ProductCategoriesPage from "./pages/Admin/Product Categories";
import ProductPage from "./pages/Admin/Products";
import ProductShowPage from "./pages/Admin/Products/show";
import ProductEditPage from "./pages/Admin/Products/edit";
import ProductCreatePage from "./pages/Admin/Products/create";
import PaymentMethodsPage from "./pages/Admin/Payment Methods";
import PaymentsPage from "./pages/Admin/Admin/Payments/PaymentsPage";





import VendorShow from "./pages/Admin/Vendors/show";



import StockIndex from "./pages/Admin/Stock";
import DashboardPage from "./pages/Admin/Dashboard/dashboard";
import UserManagement from "./pages/Admin/Users";
import RoleIndex from "./pages/Admin/User Roles";
import UserIndex from "./pages/Admin/Users";
import RoleCreate from "./pages/Admin/User Roles/create";
import RoleEdit from "./pages/Admin/User Roles/edit";
import UserCreate from "./pages/Admin/Users/create";
import UserEdit from "./pages/Admin/Users/edit";
import { Navigate } from "react-router-dom";

import StockShow from "./pages/Admin/Stock/StockShow";
import ExpenseEntry from "./pages/Admin/Expense/Create";
import ExpenseList from "./pages/Admin/Expense";
import ExpenseTypeSelect from "./pages/Admin/Expense/ExpenseTypeSelect";


///////Watch


////Issuer
import AddProductPage from "./pages/product/IssueProduct";
import IssuerProductListPage from "./pages/product/IssuerProductList";
import AssignProductsToListerPage from "./pages/product/AssignProductsToListerPage";
import ProductTimelinePage from "./pages/product/ProductTimeLine";
import IssuerProductEdit from "./pages/product/IssuerProductEdit";

////Lister
import ListerProductListPage from "./pages/lister/ListerProductList";
import ListerEditProductPage from "./pages/lister/ListerEditProductPage";



import Timeline from "./pages/Admin/TimeLine/Timeline";
import AllProduct from "./pages/Admin/Product/AllProduct";
import AssignProductsToCheckerPage from "./pages/lister/AssignProductsToCheckerPage";
import CheckerProductList from "./pages/checker/CheckerProductList";
import CheckerProductView from "./pages/checker/CheckerProductView";
import CheckerLedger from "./pages/checker/CheckerLedger";
import IssuerLedger from "./pages/product/IssuerLedger";
import AssignProductsToStockPage from "./pages/checker/AssignProductsToStockPage";
import UserProductList from "./pages/mplacer/UserProductList"
import MplacerProductView from "./pages/mplacer/MplacerProductView";
import BannerPage from "./pages/web/Banners";
import MarqueePage from "./pages/web/Marquee/Marquee";
import ProductCategoryPage from "./pages/web/ProductCategoryPage/ProductCategoryPage";
import ContactUsPage from "./pages/web/ContactUsPage/ContactUsPage";
import AboutUsPage from "./pages/web/AboutUs/AboutUs";
import BrandsPage from "./pages/web/Brands/Brands";
import BlogListPage from "./pages/web/Blogs/BlogListPage";
import BlogFormPage from "./pages/web/Blogs/BlogFormPage";
import ServiceFormPage from "./pages/web/Services/ServiceFormPage";
import ServicesListPage from "./pages/web/Services/ServicesListPage";
import IssuedProductDetailPage from "./pages/product/IssuedProductDetailPage";
import ListedProductsListPage from "./pages/lister/ListedProductsListPage";
import ApprovedProductsListPage from "./pages/checker/CheckedProductsListPage";
import WebOrderEditPage from "./pages/Admin/WebOrders/WebOrderEditPage";
import WebOrdersListPage from "./pages/Admin/WebOrders/WebOrdersListPage";
import MplacedProductList from "./pages/mplacer/MplacedProductList";
import CheckerProductDetailPage from "./pages/checker/CheckerProductDetailPage";
import MplacerProductDetailPage from "./pages/mplacer/MplacerProductDetailPage";
import MarketPlacesPage from "./pages/web/Market Places/MarketPlaces";
import OffersPage from "./pages/web/Offer/OffersPage";
import ListerAddEdit from "./pages/Admin/Admin/listers/ListerAddEdit";
import ListerIndex from "./pages/Admin/Admin/listers/ListerList";
import CheckerAddEdit from "./pages/Admin/Admin/checker/CheckerAddEdit";
import CheckerIndex from "./pages/Admin/Admin/checker/CheckerIndex";
import IssuerAddEdit from "./pages/Admin/Admin/issuer/IssuerAddEdit";
import IssuerIndex from "./pages/Admin/Admin/issuer/IssuerIndex";
import StoreManager from "./pages/Admin/Admin/Stores/StoreManager";
import ProductDetail from "./pages/Admin/Admin/Products/ProductDetail";
import ProductIndex from "./pages/Admin/Admin/Products/ProductIndex";
import ListerProductDetailPage from "./pages/lister/ListerProductDetailPage";
import StoreSellerProductsPage from "./pages/Seller/StoreSellerProductsPage";
import StoreSellerPendingProductsPage from "./pages/Seller/StoreSellerPendingProductsPage";
import StoreSellerApprovedProductsPage from "./pages/Seller/StoreSellerApprovedProductsPage";
import SellerAddProductPage from "./pages/Seller/SellerAddProductPage";
import SellerEditProductPage from "./pages/Seller/SellerEditProductPage";
import StoreSellerOrdersPage from "./pages/Seller/StoreSellerOrdersPage";
import StoreSellerLedgerPage from "./pages/Seller/StoreSellerLedgerPage";
import StoreSellerOrderViewPage from "./pages/Seller/StoreSellerOrderViewPage";
import StoreSellerOrderEditPage from "./pages/Seller/StoreSellerOrderEditPage";
import StoreSellerShipmentsPage from "./pages/Seller/StoreSellerShipmentsPage";
import StoreSellerMyShipmentsPage from "./pages/Seller/StoreSellerMyShipmentsPage";
import StoreSellerNewProductsPage from "./pages/checker/StoreSellerNewProductsPage";
import ListerDetailPage from "./pages/Admin/Admin/listers/ListerDetailPage";
import CheckerDetailPage from "./pages/Admin/Admin/checker/CheckerDetailPage";
import IssuerDetailPage from "./pages/Admin/Admin/issuer/IssuerDetailPage";
import ExpenseTypesPage from "./pages/web/Expense/ExpenseTypesPage";
import DailyExpensesPage from "./pages/web/Expense/DailyExpensesPage";
import SiteSettingsPage from "./pages/web/SiteSettings/SiteSettingsPage";
import PrivacyPolicyPage from "./pages/web/pages/PrivacyPolicyPage";
import ReturnExchangePage from "./pages/web/pages/ReturnExchangePage";
import TermsConditionsPage from "./pages/web/pages/TermsConditionsPage";
import FaqsPage from "./pages/web/pages/FaqsPage";
import MarketPlacerIndex from "./pages/Admin/Admin/Mplacer/MarketPlacerIndex";
import MarketPlacerAddEdit from "./pages/Admin/Admin/Mplacer/MarketPlacerAddEdit";
import UtilityExpenseFormPage from "./pages/web/Expense/UtilityExpenseFormPage";
import UtilityExpensesPage from "./pages/web/Expense/UtilityExpensesPage";
import EmployeesIndex from "./pages/Admin/Admin/Employee/EmployeesIndex";
import SalaryExpensesIndex from "./pages/web/Expense/SalaryExpensesIndex";
import SalaryExpenseForm from "./pages/web/Expense/SalaryExpenseForm";
import ProductFinanceReport from "./pages/Admin/Admin/Products/ProductFinanceReport";
import FinanceReportPage from "./pages/Admin/Admin/Finance/FinanceReport";
import ProductOffersListPage from "./pages/Admin/Admin/ProductOffers/ProductOffersListPage";
import ServiceContactPage from "./pages/web/Service Contact/ServiceContactPage";
import MarketPlacerDetailPage from "./pages/Admin/Admin/Mplacer/MarketPlacerDetailPage";
import StoreSellerList from "./pages/Admin/Admin/StoreSeller/StoreSellerList";
import StoreSellerDetailPage from "./pages/Admin/Admin/StoreSeller/StoreSellerDetailPage";
import StoreSellerEdit from "./pages/Admin/Admin/StoreSeller/StoreSellerEdit";
import SellerApplicationsList from "./pages/Admin/Admin/SellerApplications/SellerApplicationsList";
import SellerApplicationDetail from "./pages/Admin/Admin/SellerApplications/SellerApplicationDetail";
import SellerPayoutsAdminPage from "./pages/Admin/Admin/SellerPayouts/SellerPayoutsPage";
import ComplaintsPage from "./pages/Admin/Admin/Complaints/ComplaintsPage";
import SellerPayoutsPage from "./pages/Seller/SellerPayoutsPage";
import SellerPaymentMethodsPage from "./pages/Seller/SellerPaymentMethodsPage";
import SellerAccountPage from "./pages/Seller/SellerAccountPage";
import ListerLedger from "./pages/lister/ListerLedger";
import AssignRejectedProductsToListerPage from "./pages/checker/AssignRejectedProductsToListerPage";
import AssignMultiRole from "./pages/Admin/Admin/AssignMultiRole/AssignMultiRole";
import HandoverDismissProductsToAdminPage from "./pages/checker/HandoverDismissProductsToAdminPage";
import DismissProductIndex from "./pages/Admin/Admin/Dismiss Product/DismissProductIndex";
import PunchOrderPage from "./pages/mplacer/PunchOrderPage";
import MyOrderDetailPage from "./pages/mplacer/MyOrderDetailPage";
import MyOrdersListPage from "./pages/mplacer/MyOrdersListPage";
import MplacerLedgerPage from "./pages/mplacer/MplacerLedgerPage";
import StockKeeperProductListPage from "./pages/Storekeeper/StockKeeperProductList";
import StockKeeperProductViewPage from "./pages/Storekeeper/StockKeeperProductViewPage";
import StockKeeperAddEdit from "./pages/Admin/Admin/StockKeeper/StockKeeperAddEdit";
import StockKeeperIndex from "./pages/Admin/Admin/StockKeeper/StockKeeperIndex";
import ProductCreatorProductListPage from "./pages/ProductCreator/ProductCreatorProductListPage";
import ProductCreatorEditProductPage from "./pages/ProductCreator/ProductCreatorEditProductPage";
import ProductCreatorCreateProductPage from "./pages/ProductCreator/ProductCreatorCreateProductPage";
import SellerProductIndex from "./pages/Admin/Admin/Seller product/SellerProductIndex";
import SellerProductDetail from "./pages/Admin/Admin/Seller product/SellerProductDetail";
import SellerShippedProductsPage from "./pages/Admin/Admin/StoreSeller/SellerShippedProductsPage";
import SellerProductViewPage from "./pages/Seller/SellerProductViewPage";
import SellerShippedProductDetailPage from "./pages/Admin/Admin/StoreSeller/SellerShippedProductDetailPage";
import AssignReceivedShipmentProductsToCheckerPage from "./pages/Admin/Admin/StoreSeller/AssignProductsToCheckerPage";
const router = createBrowserRouter([
  // MAIN PAGES
  { path: "/ecommerce", element: <EcommercePage /> },
  { path: "/analytics", element: <AnalyticsPage /> },
  { path: "/crm", element: <CRMPage /> },
  { path: "/forgot-password", element: <ForgotPasswordPage /> },
  { path: "/register", element: <RegisterPage /> },
  { path: "/login", element: <LoginPage /> },
  { path: "/user-list", element: <UserListPage /> },
  { path: "/user-profile", element: <UserProfilePage /> },
  { path: "/my-account", element: <MyAccountPage /> },
  { path: "/product-list", element: <ProductListPage /> },
  { path: "/product-view", element: <ProductViewPage /> },
  { path: "/product-upload", element: <ProductUploadPage /> },
  { path: "/invoice-list", element: <InvoiceListPage /> },
  { path: "/invoice-details", element: <InvoiceDetailsPage /> },
  { path: "/order-list", element: <OrderListPage /> },
  { path: "/message", element: <MessagePage /> },
  { path: "/notification", element: <NotificationPage /> },
  { path: "/blank-page", element: <BlankPage /> },
  { path: "/settings", element: <SettingsPage /> },

  // UI PAGES
  { path: "/avatars", element: <AvatarPage /> },
  { path: "/alerts", element: <AlertPage /> },
  { path: "/buttons", element: <ButtonPage /> },
  { path: "/charts", element: <ChartPage /> },
  { path: "/tables", element: <TablePage /> },
  { path: "/fields", element: <FieldPage /> },
  { path: "/headings", element: <HeadingPage /> },
  { path: "/colors", element: <ColorPage /> },

  // OTHER PAGES
  { path: "/", element: <LoginPage /> },
  { path: "/documentation", element: <DocumentationPage /> },
  { path: "/changelog", element: <ChangeLogPage /> },
  { path: "/error", element: <ErrorPage /> },

  {
    path: "/dashboard",
    element: (
      <ProtectedRoute>
        <DashboardPage />
      </ProtectedRoute>
    ),
  },

  /////////////////////////admin///////////////////////////////
  {
    path: "/admin/web-orders",
    element: (
      <ProtectedRoute>
        <WebOrdersListPage />
      </ProtectedRoute>
    ),
  },
  {
    path: "/admin/web-orders/:id/edit",
    element: (
      <ProtectedRoute>
        <WebOrderEditPage />
      </ProtectedRoute>
    ),
  },

  {
    path: "/listers",
    element: (
      <ProtectedRoute>
        <ListerIndex />
      </ProtectedRoute>
    ),
  },
  {
    path: "/listers/create",
    element: (
      <ProtectedRoute>
        <ListerAddEdit />
      </ProtectedRoute>
    ),
  },
  {
    path: "/listers/edit/:id",
    element: (
      <ProtectedRoute>
        <ListerAddEdit />
      </ProtectedRoute>
    ),
  },
  {
    path: "/market-placer",
    element: (
      <ProtectedRoute>
        <MarketPlacerIndex />
      </ProtectedRoute>
    ),
  },
  {
    path: "/market-placer/create",
    element: (
      <ProtectedRoute>
        <MarketPlacerAddEdit />
      </ProtectedRoute>
    ),
  },
  {
    path: "/market-placer/edit/:id",
    element: (
      <ProtectedRoute>
        <MarketPlacerAddEdit />
      </ProtectedRoute>
    ),
  },
  {
    path: "/market-placer/detail/:id",
    element: (
      <ProtectedRoute>
        <MarketPlacerDetailPage />
      </ProtectedRoute>
    ),
  },
  {
    path: "/admin/lister/show/:id",
    element: (
      <ProtectedRoute>
        <ListerDetailPage />
      </ProtectedRoute>
    ),
  },

  {
    path: "/admin/stock-keeper",
    element: (
      <ProtectedRoute>
        <StockKeeperIndex />
      </ProtectedRoute>
    ),
  },
  {
    path: "/admin/stock-keeper/create",
    element: (
      <ProtectedRoute>
        <StockKeeperAddEdit />
      </ProtectedRoute>
    ),
  },
  {
    path: "/admin/stock-keeper/edit/:id",
    element: (
      <ProtectedRoute>
        <StockKeeperAddEdit />
      </ProtectedRoute>
    ),
  },

  {
    path: "/checkers",
    element: (
      <ProtectedRoute>
        <CheckerIndex />
      </ProtectedRoute>
    ),
  },
  {
    path: "/checkers/create",
    element: (
      <ProtectedRoute>
        <CheckerAddEdit />
      </ProtectedRoute>
    ),
  },
  {
    path: "/checkers/edit/:id",
    element: (
      <ProtectedRoute>
        <CheckerAddEdit />
      </ProtectedRoute>
    ),
  },
  {
    path: "/checkers/show/:id",
    element: (
      <ProtectedRoute>
        <CheckerDetailPage />
      </ProtectedRoute>
    ),
  },

  {
    path: "/assign-multi-role",
    element: (
      <ProtectedRoute>
        <AssignMultiRole />
      </ProtectedRoute>
    ),
  },
  {
    path: "/issuers",
    element: (
      <ProtectedRoute>
        <IssuerIndex />
      </ProtectedRoute>
    ),
  },
  {
    path: "/issuers/create",
    element: (
      <ProtectedRoute>
        <IssuerAddEdit />
      </ProtectedRoute>
    ),
  },
  {
    path: "/issuers/edit",
    element: (
      <ProtectedRoute>
        <IssuerAddEdit />
      </ProtectedRoute>
    ),
  },
  {
    path: "/issuers/show/:id",
    element: (
      <ProtectedRoute>
        <IssuerDetailPage />
      </ProtectedRoute>
    ),
  },

  {
    path: "/stores",
    element: (
      <ProtectedRoute>
        <StoreManager />
      </ProtectedRoute>
    ),
  },
  {
    path: "/product-offers",
    element: (
      <ProtectedRoute>
        <ProductOffersListPage />
      </ProtectedRoute>
    ),
  },

  {
    path: "/products",
    element: (
      <ProtectedRoute>
        <ProductIndex />
      </ProtectedRoute>
    ),
  },
  {
    path: "/dismiss-products",
    element: (
      <ProtectedRoute>
        <DismissProductIndex />
      </ProtectedRoute>
    ),
  },
  {
    path: "/admin/store-sellers",
    element: (
      <ProtectedRoute>
        <StoreSellerList />
      </ProtectedRoute>
    ),
  },
  {
    path: "/admin/seller-applications",
    element: (
      <ProtectedRoute>
        <SellerApplicationsList />
      </ProtectedRoute>
    ),
  },
  {
    path: "/admin/seller-applications/:id",
    element: (
      <ProtectedRoute>
        <SellerApplicationDetail />
      </ProtectedRoute>
    ),
  },
  {
    path: "/admin/seller-payouts",
    element: (
      <ProtectedRoute>
        <SellerPayoutsAdminPage />
      </ProtectedRoute>
    ),
  },
  {
    path: "/admin/complaints",
    element: (
      <ProtectedRoute>
        <ComplaintsPage />
      </ProtectedRoute>
    ),
  },
  {
    path: "/seller-payouts",
    element: (
      <ProtectedRoute>
        <SellerPayoutsPage />
      </ProtectedRoute>
    ),
  },
  {
    path: "/seller-payment-methods",
    element: (
      <ProtectedRoute>
        <SellerPaymentMethodsPage />
      </ProtectedRoute>
    ),
  },
  {
    path: "/seller-account",
    element: (
      <ProtectedRoute>
        <SellerAccountPage />
      </ProtectedRoute>
    ),
  },

  {
    path: "/admin/seller-products",
    element: (
      <ProtectedRoute>
        <SellerProductIndex />
      </ProtectedRoute>
    ),
  },
  {
    path: "/admin/seller-shipped-products",
    element: (
      <ProtectedRoute>
        <SellerShippedProductsPage />
      </ProtectedRoute>
    ),
  },
  {
    path: "/admin/seller-shipped-products/:id",
    element: (
      <ProtectedRoute>
        <SellerShippedProductDetailPage />
      </ProtectedRoute>
    ),
  },
  {
    path: "/admin/handover-to-checker",
    element: (
      <ProtectedRoute>
        <AssignReceivedShipmentProductsToCheckerPage />
      </ProtectedRoute>
    ),
  },
  {
    path: "/admin/seller-products/detail",
    element: (
      <ProtectedRoute>
        <SellerProductDetail />
      </ProtectedRoute>
    ),
  },

  {
    path: "/admin/payments",
    element: (
      <ProtectedRoute>
        <PaymentsPage />
      </ProtectedRoute>
    ),
  },
  {
    path: "/admin/store-sellers/:id",
    element: (
      <ProtectedRoute>
        <StoreSellerDetailPage />
      </ProtectedRoute>
    ),
  },
  {
    path: "/admin/store-sellers/:id/edit",
    element: (
      <ProtectedRoute>
        <StoreSellerEdit />
      </ProtectedRoute>
    ),
  },
  {
    path: "/products-wise-report",
    element: (
      <ProtectedRoute>
        <ProductFinanceReport />
      </ProtectedRoute>
    ),
  },
  {
    path: "/finace-report",
    element: (
      <ProtectedRoute>
        <FinanceReportPage />
      </ProtectedRoute>
    ),
  },
  {
    path: "/product/edit",
    element: (
      <ProtectedRoute>
        <ProductEditPage />
      </ProtectedRoute>
    ),
  },
  {
    path: "/products/detail",
    element: (
      <ProtectedRoute>
        <ProductDetail />
      </ProtectedRoute>
    ),
  },

  /////////////////////////issuer///////////////////////////////

  {
    path: "/issue-product",
    element: (
      <ProtectedRoute>
        <AddProductPage />
      </ProtectedRoute>
    ),
  },
  {
    path: "/assign-products-to-lister",
    element: (
      <ProtectedRoute>
        <AssignProductsToListerPage />
      </ProtectedRoute>
    ),
  },

  {
    path: "/issue-product-list",
    element: (
      <ProtectedRoute>
        <IssuerProductListPage />
      </ProtectedRoute>
    ),
  },
  {
    path: "/issue-product-edit",
    element: (
      <ProtectedRoute>
        <IssuerProductEdit />
      </ProtectedRoute>
    ),
  },
  {
    path: "/issuer/issued-products/:id",
    element: (
      <ProtectedRoute>
        <IssuedProductDetailPage />
      </ProtectedRoute>
    ),
  },
  {
    path: "/issuer/ledger",
    element: (
      <ProtectedRoute>
        <IssuerLedger />
      </ProtectedRoute>
    ),
  },
  {
    path: "/product-timeline/:id",
    element: (
      <ProtectedRoute>
        <Timeline />
      </ProtectedRoute>
    ),
  },


  /////////////////////////Lister///////////////////////////////
  {
    path: "/lister-products",
    element: (
      <ProtectedRoute>
        <ListerProductListPage />
      </ProtectedRoute>
    ),
  },
  {
    path: "/lister-product-edit",
    element: (
      <ProtectedRoute>
        <ListerEditProductPage />
      </ProtectedRoute>
    ),
  },
  {
    path: "/lister-product-view/:id",
    element: (
      <ProtectedRoute>
        <ListerProductDetailPage />
      </ProtectedRoute>
    ),
  },
  {
    path: "/ledger",
    element: (
      <ProtectedRoute>
        <ListerLedger />
      </ProtectedRoute>
    ),
  },



  {
    path: "/handover-products-to-checker",
    element: (
      <ProtectedRoute>
        <AssignProductsToCheckerPage />
      </ProtectedRoute>
    ),
  },
  {
    path: "/listed-products",
    element: (
      <ProtectedRoute>
        <ListedProductsListPage />
      </ProtectedRoute>
    ),
  },

  /////////////////////////Checker///////////////////////////////


  {
    path: "/checker-products",
    element: (
      <ProtectedRoute>
        <CheckerProductList />
      </ProtectedRoute>
    ),
  },
  {
    path: "/checker/ledger",
    element: (
      <ProtectedRoute>
        <CheckerLedger />
      </ProtectedRoute>
    ),
  },
  {
    path: "/store-seller-products",
    element: (
      <ProtectedRoute>
        <StoreSellerNewProductsPage />
      </ProtectedRoute>
    ),
  },

  {
    path: "/checker-products-edit/:id",
    element: (
      <ProtectedRoute>
        <CheckerProductView />
      </ProtectedRoute>
    ),
  },
  {
    path: "/checker-products-view/:id",
    element: (
      <ProtectedRoute>
        <CheckerProductDetailPage />
      </ProtectedRoute>
    ),
  },

  {
    path: "/handover-products-to-stock",
    element: (
      <ProtectedRoute>
        <AssignProductsToStockPage />
      </ProtectedRoute>
    )
  },
  {
    path: "/handover-rejected-products-to-lister",
    element: (
      <ProtectedRoute>
        <AssignRejectedProductsToListerPage />
      </ProtectedRoute>
    )
  },
  {
    path: "/handover-dismiss-products-to-admin",
    element: (
      <ProtectedRoute>
        <HandoverDismissProductsToAdminPage />
      </ProtectedRoute>
    )
  },
  {
    path: "/approved-products",
    element: (
      <ProtectedRoute>
        <ApprovedProductsListPage />
      </ProtectedRoute>
    ),
  },


  {
    path: "/mplacer-products",
    element: (
      <ProtectedRoute>
        <UserProductList />
      </ProtectedRoute>
    )
  },
  {
    path: "/mplaced-products",
    element: (
      <ProtectedRoute>
        <MplacedProductList />
      </ProtectedRoute>
    )
  },
  {
    path: "/mplacer-products-edit",
    element: (
      <ProtectedRoute>
        <MplacerProductView />
      </ProtectedRoute>
    ),
  },
  {
    path: "/mplacer-products-view",
    element: (
      <ProtectedRoute>
        <MplacerProductDetailPage />
      </ProtectedRoute>
    ),
  },
  {
    path: "/market-placer/my-order",
    element: (
      <ProtectedRoute>
        <MyOrdersListPage />
      </ProtectedRoute>
    ),
  },
  {
    path: "/market-placer/ledger",
    element: (
      <ProtectedRoute>
        <MplacerLedgerPage />
      </ProtectedRoute>
    ),
  },
  {
    path: "/market-placer/my-order/:id",
    element: (
      <ProtectedRoute>
        <MyOrderDetailPage />
      </ProtectedRoute>
    ),
  },
  {
    path: "/market-placer/punch-order",
    element: (
      <ProtectedRoute>
        <PunchOrderPage />
      </ProtectedRoute>
    ),
  },


  /////////////////////////Product Creator///////////////////////////////
  {
    path: "/product-creator/products",
    element: (
      <ProtectedRoute>
        <ProductCreatorProductListPage />
      </ProtectedRoute>
    ),
  },
  {
    path: "/product-creator/products/create",
    element: (
      <ProtectedRoute>
        <ProductCreatorCreateProductPage />
      </ProtectedRoute>
    ),
  },
  {
    path: "/product-creator/products/:id/edit",
    element: (
      <ProtectedRoute>
        <ProductCreatorEditProductPage />
      </ProtectedRoute>
    ),
  },

  /////////////////////////Store Keeper///////////////////////////////
  {
    path: "/stock-keeper-products",
    element: (
      <ProtectedRoute>
        <StockKeeperProductListPage />
      </ProtectedRoute>
    ),
  },
  {
    path: "/stock-keeper-product-view/:id",
    element: (
      <ProtectedRoute>
        <StockKeeperProductViewPage />
      </ProtectedRoute>
    ),
  },

  /////////////////////////Seller///////////////////////////////

  {
    path: "/seller-products",
    element: (
      <ProtectedRoute>
        <StoreSellerProductsPage />
      </ProtectedRoute>
    ),
  },
  {
    path: "/seller-pending-products",
    element: (
      <ProtectedRoute>
        <StoreSellerPendingProductsPage />
      </ProtectedRoute>
    ),
  },
  {
    path: "/seller-approved-products",
    element: (
      <ProtectedRoute>
        <StoreSellerApprovedProductsPage />
      </ProtectedRoute>
    ),
  },

  {
    path: "/seller-store-shipments/create",
    element: (
      <ProtectedRoute>
        <StoreSellerShipmentsPage />
      </ProtectedRoute>
    ),
  },
  {
    path: "/seller-store-shipments",
    element: (
      <ProtectedRoute>
        <StoreSellerMyShipmentsPage />
      </ProtectedRoute>
    ),
  },
  {
    path: "/seller-store-my-shipments",
    element: (
      <ProtectedRoute>
        <StoreSellerMyShipmentsPage />
      </ProtectedRoute>
    ),
  },
  {
    path: "/seller-store-orders",
    element: (
      <ProtectedRoute>
        <StoreSellerOrdersPage />
      </ProtectedRoute>
    ),
  },
  {
    path: "/seller-store-orders/:id/edit",
    element: (
      <ProtectedRoute>
        <StoreSellerOrderEditPage />
      </ProtectedRoute>
    ),
  },
  {
    path: "/seller-store-orders/:id",
    element: (
      <ProtectedRoute>
        <StoreSellerOrderViewPage />
      </ProtectedRoute>
    ),
  },
  {
    path: "/seller-ledger",
    element: (
      <ProtectedRoute>
        <StoreSellerLedgerPage />
      </ProtectedRoute>
    ),
  },
  {
    path: "/seller-product-create",
    element: (
      <ProtectedRoute>
        <SellerAddProductPage />
      </ProtectedRoute>
    ),
  },
  {
    path: "/seller-product-edit",
    element: (
      <ProtectedRoute>
        <SellerEditProductPage />
      </ProtectedRoute>
    ),
  },
  {
    path: "/store-seller/product-view/:id",
    element: (
      <ProtectedRoute>
        <SellerProductViewPage />
      </ProtectedRoute>
    ),
  },

  {
    path: "/timeline",
    element: (

      <Timeline />

    ),
  },
  {
    path: "/all-products",
    element: (

      <AllProduct />

    ),
  },


  /////////////////////////Web///////////////////////////////
  {
    path: "/banners",
    element: (
      <ProtectedRoute>
        <BannerPage />
      </ProtectedRoute>
    ),
  },
  {
    path: "/marquee",
    element: (
      <ProtectedRoute>
        <MarqueePage />
      </ProtectedRoute>
    ),
  },
  {
    path: "/market-places",
    element: (
      <ProtectedRoute>
        <MarketPlacesPage />
      </ProtectedRoute>
    ),
  },
  {
    path: "/offers",
    element: (
      <ProtectedRoute>
        <OffersPage />
      </ProtectedRoute>
    ),
  },
  {
    path: "/product/categories",
    element: (
      <ProtectedRoute>
        <ProductCategoryPage />
      </ProtectedRoute>
    ),
  },
  {
    path: "/contact-us",
    element: (
      <ProtectedRoute>
        <ContactUsPage />
      </ProtectedRoute>
    ),
  },
  {
    path: "/about-us",
    element: (
      <ProtectedRoute>
        <AboutUsPage />
      </ProtectedRoute>
    ),
  },
  {
    path: "/brands",
    element: (
      <ProtectedRoute>
        <BrandsPage />
      </ProtectedRoute>
    ),
  },
  {
    path: "/blogs",
    element: (
      <ProtectedRoute>
        <BlogListPage />
      </ProtectedRoute>
    ),
  },
  {
    path: "/blogs/create",
    element: (
      <ProtectedRoute>
        <BlogFormPage />
      </ProtectedRoute>
    ),
  },
  {
    path: "/blogs/edit/:id",
    element: (
      <ProtectedRoute>
        <BlogFormPage />
      </ProtectedRoute>
    ),
  },
  {
    path: "/services",
    element: (
      <ProtectedRoute>
        <ServicesListPage />
      </ProtectedRoute>
    ),
  },
  {
    path: "/services/create",
    element: (
      <ProtectedRoute>
        <ServiceFormPage />
      </ProtectedRoute>
    ),
  },
  {
    path: "/services/edit/:id",
    element: (
      <ProtectedRoute>
        <ServiceFormPage />
      </ProtectedRoute>
    ),
  },
  {
    path: "/services-contacts",
    element: (
      <ProtectedRoute>
        <ServiceContactPage />
      </ProtectedRoute>
    ),
  },
  {
    path: "/site-settings",
    element: (
      <ProtectedRoute>
        <SiteSettingsPage />
      </ProtectedRoute>
    ),
  },
  {
    path: "/privacy-policy",
    element: (
      <ProtectedRoute>
        <PrivacyPolicyPage />
      </ProtectedRoute>
    ),
  },
  {
    path: "/return-exchange",
    element: (
      <ProtectedRoute>
        <ReturnExchangePage />
      </ProtectedRoute>
    ),
  },
  {
    path: "/terms-condition",
    element: (
      <ProtectedRoute>
        <TermsConditionsPage />
      </ProtectedRoute>
    ),
  },
  {
    path: "/faqs-page",
    element: (
      <ProtectedRoute>
        <FaqsPage />
      </ProtectedRoute>
    ),
  },
  {
    path: "/expenses-type",
    element: (
      <ProtectedRoute >
        <ExpenseTypesPage />
      </ProtectedRoute>
    ),
  },
  {
    path: "/daily-expenses",
    element: (
      <ProtectedRoute >
        <DailyExpensesPage />
      </ProtectedRoute>
    ),
  },
  {
    path: "/utility-expenses",
    element: (
      <ProtectedRoute>
        <UtilityExpensesPage />
      </ProtectedRoute>
    ),
  },
  {
    path: "/utility-expenses/create",
    element: (
      <ProtectedRoute>
        <UtilityExpenseFormPage />
      </ProtectedRoute>
    ),
  },
  {
    path: "/utility-expenses/edit/:id",
    element: (
      <ProtectedRoute>
        <UtilityExpenseFormPage />
      </ProtectedRoute>
    ),
  },
  {
    path: "/salary-expenses",
    element: (
      <ProtectedRoute>
        <SalaryExpensesIndex />
      </ProtectedRoute>
    ),
  },
  {
    path: "/salary-expenses/create",
    element: (
      <ProtectedRoute>
        <SalaryExpenseForm />
      </ProtectedRoute>
    ),
  },
  {
    path: "/salary-expenses/edit/:id",
    element: (
      <ProtectedRoute>
        <SalaryExpenseForm />
      </ProtectedRoute>
    ),
  },
  {
    path: "/users",
    element: (
      <ProtectedRoute permission="Users view">
        <UserIndex />
      </ProtectedRoute>
    ),
  },
  {
    path: "/user-create",
    element: (
      <ProtectedRoute permission="Users create">
        <UserCreate />
      </ProtectedRoute>
    ),
  },
  {
    path: "/user-edit/:id",
    element: (
      <ProtectedRoute permission="Users edit">
        <UserEdit />
      </ProtectedRoute>
    ),
  },
  {
    path: "/users-roles",
    element: (
      <ProtectedRoute permission="User roles view">
        <RoleIndex />
      </ProtectedRoute>
    ),
  },
  {
    path: "/role-create",
    element: (
      <ProtectedRoute permission="User roles create">
        <RoleCreate />
      </ProtectedRoute>
    ),
  },
  {
    path: "/role-edit/:id",
    element: (
      <ProtectedRoute permission="User roles edit">
        <RoleEdit />
      </ProtectedRoute>
    ),
  },
  {
    path: "/vendor-list",
    element: (
      <ProtectedRoute permission="vendor.view">
        <VendorsPage />
      </ProtectedRoute>
    ),
  },
  {
    path: "/vendor-show/:id",
    element: (
      <ProtectedRoute permission="vendor.view">
        <VendorShow />
      </ProtectedRoute>
    ),
  },
  {
    path: "/products-list",
    element: (
      <ProtectedRoute permission="Products view">
        <ProductPage />
      </ProtectedRoute>
    ),
  },
  {
    path: "/product-create",
    element: (
      <ProtectedRoute permission="Products create">
        <ProductCreatePage />
      </ProtectedRoute>
    ),
  },
  {
    path: "/product-edit/:slug",
    element: (
      <ProtectedRoute permission="Products edit">
        <ProductEditPage />
      </ProtectedRoute>
    ),
  },
  {
    path: "/product-show/:id",
    element: (
      <ProtectedRoute permission="Products view">
        <ProductShowPage />
      </ProtectedRoute>
    ),
  },






  {
    path: "/expense-select",
    element: <ExpenseTypeSelect />,
  },

  {
    path: "/expense-create/:type",
    element: <ExpenseEntry />,
  },
  {
    path: "/expense-list",
    element: (

      <ExpenseList />
    ),
  },
  {
    path: "/stock",
    element: (
      // <ProtectedRoute>
      <StockIndex />
      // </ProtectedRoute>
    ),
  },
  {
    path: "/stock/show/:productId",
    element: (
      // <ProtectedRoute>
      <StockShow />
      // </ProtectedRoute>
    ),
  },

  //////////// Settings//////
  {
    path: "/product-categories",
    element: (
      <ProtectedRoute permission="Settings">
        <ProductCategoriesPage />
      </ProtectedRoute>
    ),
  },
  {
    path: "/payment-methods",
    element: (
      <ProtectedRoute>
        <PaymentMethodsPage />
      </ProtectedRoute>
    ),
  },
  {
    path: "/employees",
    element: (
      <ProtectedRoute>
        <EmployeesIndex />
      </ProtectedRoute>
    ),
  },
]);
document.addEventListener("wheel", (e) => {
  if (document.activeElement.type === "number") {
    document.activeElement.blur()
  }
})
createRoot(document.getElementById("root")).render(
  <ThemeProvider>
    <LoaderProvider>
      <TranslatorProvider>
        <SidebarProvider>
          <AuthProvider>
            <ValidationProvider>
              <RouterProvider router={router} />
            </ValidationProvider>
          </AuthProvider>
        </SidebarProvider>
      </TranslatorProvider>
    </LoaderProvider>
  </ThemeProvider>,
);
